<template>
  <div id="Article">
    <div class="ArticleBanner" :style="{backgroundImage:'url('+bannerImg+')'}"></div>
    <div class="Article-content">
      <div class="Article-content-inner">
        <el-breadcrumb class="ArticleBreadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item v-for="item in categories" :key="item.id">
            <router-link v-if="item.id==3" :to="'/?type='+item.id">{{item.title}}</router-link>
            <router-link v-else-if="item.id==4" :to="'/?type='+item.id">{{item.title}}</router-link>
            <router-link v-else-if="item.type == 0&&item.id!=2&&categories[0].id!=2" :to="'/ArticleList?id='+item.id">{{item.title}}</router-link>
            <router-link v-else-if="item.type == 0&&(item.id==2||categories[0].id == 2)" :to="'/BrightColors?id='+item.id">{{item.title}}</router-link>
            <router-link v-else-if="item.type == 1" :to="'/Article?id='+item.article_id">{{item.title}}</router-link>
            <a v-else-if="item.type == 2" :href="item.url">{{item.title}}</a>
            <router-link v-else :to="'/'+item.relative">{{item.title}}</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item style="cursor:default !important;">{{title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <p class="Article-title">{{title}}</p>
        <p class="Article-subtitle" v-if="subtitle">——{{subtitle}}</p>
        <p class="Article-time">发布时间 : {{time}}<span style="margin-left:28px;" v-if="author">作者 : {{author}}</span></p>
        <div class="Article-inner" v-html="article"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Article',
  data:function(){
    return{
      title:'',
      subtitle:'',
      time:'',
      article:'',
      categories:[],
      bannerImg:'',
      author:''
    }
  },
  created(){
    this.title = ''
    this.subtitle = ''
    this.time = ''
    this.article = ''
    this.$store.dispatch('getArticle',this.$route.query.id).then(res => {
      this.title = res.data.title
      $('title').text(res.data.title)
      this.subtitle = res.data.sub_title
      this.time = res.data.release_time
      this.article = res.data.content
      this.categories = res.data.categories
      this.bannerImg = res.data.category_image.image
      this.author = res.data.author
      let that = this
      that.$nextTick(function(){
        that.setHeight()
      })
    })
  },
  methods:{
    setHeight(){
      let footerPC = $('.footer-PC')[0]
      $('#Article').css('minHeight','calc(100vh - '+(footerPC.offsetHeight+40)+'px)');
    }
  },
  watch:{
    '$route':function(val,oldval){
      this.title = ''
      this.subtitle = ''
      this.time = ''
      this.article = ''
      this.$store.dispatch('getArticle',this.$route.query.id).then(res => {
        this.title = res.data.title
        this.time = res.data.release_time
        this.subtitle = res.data.sub_title
        $('title').text(res.data.title)
        this.article = res.data.content
        this.categories = res.data.categories
        this.bannerImg = res.data.category_image.image
        this.author = res.data.author
        let that = this
        that.$nextTick(function(){
          that.setHeight()
        })
      })
    }
  }
}
</script>

<style lang="scss">
#Article {
  padding-bottom: 40px;
  background-color: #f9f9f9;
  min-height: calc(100vh - 366px);
  .ArticleBanner{
    width: 100%;
    height: 250px;
    min-width: 1240px;
    position: absolute;
    background-size: cover;
    background-repeat:no-repeat;
    background-position: center;
  }
  .Article-content{
    width: 100%;
    min-width: 1240px;
    padding-top: 230px;
    position: relative;
    .Article-content-inner{
      padding: 40px 100px;
      margin: 0 auto;
      border-radius: 4px;
      width: calc(100% - 340px);
      background-color: #ffffff;
      -webkit-border-radius: 4px;
      .ArticleBreadcrumb{
        color: #282828 !important;
        font-size: 16px !important;
        .el-breadcrumb__item{
          .el-breadcrumb__inner{
            color: #282828 !important;
            font-size: 16px !important;
            font-weight: normal !important;
            a{
              color: #282828 !important;
              font-size: 16px !important;
              cursor: pointer !important;
              font-weight: normal !important;
            }
          }
          .el-breadcrumb__separator{
            color: #282828 !important;
          }
        }
      }
      .Article-title{
        color: #282828;
        font-size: 24px;
        margin-top: 38px;
        line-height: 28px;
        text-align: center;
      }
      .Article-subtitle{
        color: #282828;
        font-size: 16px;
        margin-top: 16px;
        line-height: 18px;
        text-align: center;
        padding-bottom: 20px;
      }
      .Article-time{
        color: #282828;
        font-size: 14px;
        margin-top: 17px;
        line-height: 16px;
        text-align: center;
      }
      .Article-inner{
        width: 100%;
        margin-top: 39px;
      }
      .Article-inner:after{content:"";display:block;clear:both;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Article/index.vue